import React, { FC } from 'react';

import HighContrastBorder from '../HighContrastBorder';

import { getClassNames } from './PageLayoutFooter.styles';

const { footer } = getClassNames();

const PageLayoutFooter: FC = ({ children }) => (
  <footer className={footer}>
    <HighContrastBorder top={true}>{children}</HighContrastBorder>
  </footer>
);

export default PageLayoutFooter;
